<template lang='pug'>
//- 完成註冊區塊
div(:class='$style[`cc-popbox-loading`]')
  div(:class='$style[`cc-popbox-loading-wrap`]')
    IconLoading(:size='60' :color='`#b1b1b1`')

</template>

<script>
// import { mapMutations } from 'vuex';

import IconLoading from '../../icon/Loading';

export default {
  components: {
    IconLoading,
  },

  props: {
    // 確認打勾圖樣顏色
    // 訊息文字
    textInfo: {
      type: String,
      default: '',
    },
    // 是否顯示按鈕
    // button: {
    //   type: Boolean,
    //   default: false
    // },
    // 按鈕的文字
    // buttonText: {
    //   type: String,
    //   default: '確定'
    // },
    // 跳轉延遲時間
    // linkDelay: {
    //   type: Number,
    //   default: 1400
    // },
    // 跳轉POPBOX至x
    // linkPopBoxTo: {
    //   type: String,
    //   default: ''
    // },
    // 跳轉頁面至x
    // linkRouterTo: {
    //   type: String,
    //   default: ''
    // },
  },

  // data() {
  //   return {}
  // },

};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popLoading.scss';
</style>
